import { GzInProductTrialsHeaderWebComponent } from './component/GzInProductTrialsHeaderWebComponent';

export { GzInProductTrialsHeaderWebComponent };
